<template>
  <div>
    <div class="box">
      <div class="table_box">
        <el-table
          :data="tableData"
          style="width: 100%; height: 100%"
          :header-cell-style="{
            background: '#FAFAFA',
          }"
          fit
          border
          ref="userlist"
        >
          <el-table-column
            :label="userinfo.unit_name + '报表上传'"
            label-class-name="title_top"
          >
            <el-table-column
              prop="year"
              label="年度"
              width="100"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="basicqk"
              show-overflow-tooltip
              label="基本情况"
              min-width="180"
              align="center"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.basicqk == 0">
                  <el-button style="color: #333" type="text" circle
                    >未填写</el-button
                  >
                  |
                  <el-button
                    type="text"
                    circle
                    @click="jump('/Basic', scope.row)"
                    >去填写</el-button
                  >
                </div>
                <div v-if="scope.row.basicqk == 1">
                  <el-button style="color: #333" type="text" circle
                    >已填写</el-button
                  >
                  |
                  <el-button
                    type="text"
                    circle
                    @click="jump('/Basic', scope.row)"
                  >
                    修 改
                  </el-button>
                </div>
                <div v-if="scope.row.basicqk == 2">
                  <el-button style="color: #333" type="text" circle
                    >已填写</el-button
                  >
                  |
                  <el-button
                    type="text"
                    circle
                    @click="jump('/Basic', scope.row)"
                  >
                    查 看
                  </el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="person"
              show-overflow-tooltip
              label="人员情况"
              min-width="180"
              align="center"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.person == 0">
                  <el-button style="color: #333" type="text" circle
                    >未填写</el-button
                  >
                  |
                  <el-button
                    type="text"
                    circle
                    @click="jump('/Personnel', scope.row)"
                    >去填写</el-button
                  >
                </div>
                <div v-if="scope.row.person == 1">
                  <el-button style="color: #333" type="text" circle
                    >已填写</el-button
                  >
                  |
                  <el-button
                    type="text"
                    circle
                    @click="jump('/Personnel', scope.row)"
                  >
                    修 改
                  </el-button>
                </div>
                <div v-if="scope.row.person == 2">
                  <el-button style="color: #333" type="text" circle
                    >已填写</el-button
                  >
                  |
                  <el-button
                    type="text"
                    circle
                    @click="jump('/Personnel', scope.row)"
                  >
                    查 看
                  </el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="business"
              show-overflow-tooltip
              label="业务情况"
              min-width="180"
              align="center"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.business == 0">
                  <el-button style="color: #333" type="text" circle
                    >未填写</el-button
                  >
                  |
                  <el-button
                    type="text"
                    circle
                    @click="jump('/business', scope.row)"
                    >去填写</el-button
                  >
                </div>
                <div v-if="scope.row.business == 1">
                  <el-button style="color: #333" type="text" circle
                    >已填写</el-button
                  >
                  |
                  <el-button
                    type="text"
                    circle
                    @click="jump('/business', scope.row)"
                  >
                    修 改
                  </el-button>
                </div>
                <div v-if="scope.row.business == 2">
                  <el-button style="color: #333" type="text" circle
                    >已填写</el-button
                  >
                  |
                  <el-button
                    type="text"
                    circle
                    @click="jump('/business', scope.row)"
                  >
                    查 看
                  </el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="finance"
              show-overflow-tooltip
              label="财务情况"
              min-width="180"
              align="center"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.finance == 0">
                  <el-button style="color: #333" type="text" circle
                    >未填写</el-button
                  >
                  |
                  <el-button
                    type="text"
                    circle
                    @click="jump('/Financial', scope.row)"
                    >去填写</el-button
                  >
                </div>
                <div v-if="scope.row.finance == 1">
                  <el-button style="color: #333" type="text" circle
                    >已填写</el-button
                  >
                  |
                  <el-button
                    type="text"
                    circle
                    @click="jump('/Financial', scope.row)"
                  >
                    修 改
                  </el-button>
                </div>
                <div v-if="scope.row.finance == 2">
                  <el-button style="color: #333" type="text" circle
                    >已填写</el-button
                  >
                  |
                  <el-button
                    type="text"
                    circle
                    @click="jump('/Financial', scope.row)"
                  >
                    查 看
                  </el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="shangbao"
              show-overflow-tooltip
              label="报表状态"
              min-width="180"
              align="center"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.shangbao == 0">未上报</span>
                <span v-if="scope.row.shangbao == 1" style="color: #e6a23c"
                  >已上报,待审核</span
                >
                <span v-if="scope.row.shangbao == 2" style="color: red"
                  >拒绝</span
                >
                <span v-if="scope.row.shangbao == 3" style="color: #1aa97b"
                  >待修改</span
                >
                <span v-if="scope.row.shangbao == 4" style="color: #67c23a"
                  >审核通过</span
                >
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              width="200"
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  circle
                  @click="Submit(scope.row)"
                  v-if="
                    scope.row.operate == 'initial' ||
                    scope.row.operate == 'notsub'
                  "
                  >上报</el-button
                >
                <el-button
                  type="text"
                  circle
                  v-if="scope.row.operate == 'review'"
                  >待审核</el-button
                >
                <el-button
                  type="text"
                  circle
                  v-if="
                    scope.row.operate == 'modify_agree' ||
                    scope.row.operate == 'refuse'
                  "
                  @click="Submit(scope.row)"
                  >重新上报</el-button
                >
                <el-button
                  type="text"
                  circle
                  v-if="
                    scope.row.operate == 'normal' ||
                    scope.row.operate == 'modify_refuse'
                  "
                  >公示中</el-button
                >
                <el-button
                  type="text"
                  circle
                  v-if="scope.row.operate == 'modify_apply'"
                  >已申请修改，待审核</el-button
                >
                <el-button
                  type="text"
                  circle
                  @click="Submitsq(scope.row)"
                  v-if="
                    scope.row.operate == 'normal' ||
                    scope.row.operate == 'modify_refuse'
                  "
                  >申请修改</el-button
                >
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination_box">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="page"
          layout=" prev, pager"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      userinfo: JSON.parse(localStorage.getItem("info")),

      tableData: [], //table数据
      page: 1, //当前页
      total: 0,
    };
  },
  mounted() {
    this.getinfo();
  },
  methods: {
    Submit(e) {
      let that = this;
      let data = {
        id: e.id,
      };
      // console.log(that.levrl);
      that.$http.post("institution/common/escalation", data).then((res) => {
        if (res.code == 1) {
          this.$confirm(
            "河南省建设工程招标投标协会2022年度报表已上报平台，请耐心等待平台审核，审核结果将在站内通知公布。",
            "温馨提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              customClass: "sc",
              showClose: false,
            }
          )
            .then(() => {
              this.getinfo();
            })
            .catch(() => {
              this.getinfo();
            });
        } else {
          this.$self.ts(res).then(() => {
            this.getinfo();
          });
        }
      });
    },
    Submitsq(e) {
      let that = this;
      let data = {
        id: e.id,
      };
      // console.log(that.levrl);
      that.$http.post("institution/common/applyModify", data).then((res) => {
        if (res.code == 1) {
          this.$confirm(
            "您已提交申请修改，审核通过之后可以进行修改，请耐心等待平台审核，审核结果将在站内通知公布。",
            "温馨提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              customClass: "sc",
              showClose: false,
            }
          )
            .then(() => {
              this.getinfo();
            })
            .catch(() => {
              this.getinfo();
            });
        } else {
          this.$self.ts(res).then(() => {
            this.getinfo();
          });
        }
      });
    },
    //获取表格信息
    getinfo() {
      let that = this;
      let data = {
        page: that.page,
      };
      // console.log(that.levrl);
      that.$http.post("institution/common/getReportnew", data).then((res) => {
        if (res.code == 1) {
          that.tableData = res.data.data;
          that.total = res.data.count;
        } else {
          that.tableData = [];
          that.total = 0;
        }
      });
    },
    //翻页
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.page = val;
      this.getinfo();
    },
    //跳转
    jump(url, e) {
      // console.log(url, e);
      this.$router.push({ path: url, query: { year: e.year } });
    },
  },
};
</script>
<style>
.sc {
  width: 6rem;
}
.sc .el-message-box__content {
  padding: 0.675rem 0.5rem;
  font-size: 0.2rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 0.375rem;
  text-align: center;
}
.sc .el-button--small {
  font-size: 0.2rem;
  padding: 0.14rem 0.3rem;
}
</style>
<style scoped>
.table_box {
  margin: 20px 20px 43px;
}

.pagination_box {
  text-align: center;
}

::v-deep .el-table {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}

::v-deep .el-table--border .el-table__cell {
  border-color: #e8e8e8;
  height: 40px !important;
  white-space: nowrap;
  font-size: 19px;
  color: #262626;
  font-family: Microsoft YaHei;
  font-weight: 400;
  text-align: center;
}

::v-deep .el-table thead {
  height: 64px;
}

::v-deep .el-tooltip {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}

::v-deep .el-table .el-button {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
}

::v-deep .title_top {
  background: #1954a4 !important;
  text-align: center !important;
  font-size: 16px !important;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #ffffff;
}
</style>